import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as types from './types';

export const resetPrintResponse = () => {
  return dispatch => {
    dispatch({
      type: types.RESET_PRINT_RESPONSE,
    });
  };
};

export const getTxnTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REPORT_TRANSACTION_TYPES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        'TransactionHistoryReports/GetTxnTypes'
      );
      dispatch(
        success(types.REPORT_TRANSACTION_TYPES, response.data.Data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Transaction Types. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.REPORT_TRANSACTION_TYPES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.REPORT_TRANSACTION_TYPES_LOADING, false));
    }
  };
};

export const printReportData = (apiUrl, requestObj) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        apiUrl,
        requestObj
      );
      if (response.data.Data.Data) {
        dispatch(success(types.PRINT_REPORT_DATA, response.data.Data.Data));
      } else {
        dispatch({
          type: types.SET_PRINT_RESPONSE_EMPTY,
        });
      }
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while printing report. Please try again.',
      };
      dispatch(
        handleErrorException(err, types.PRINT_REPORT_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_REPORT_LOADING, false));
    }
  };
};

export const clearPrintReportError = () => {
  return {
    type: types.CLEAR_PRINT_REPORT_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/commonState/actions.js